import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Star, Clock, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const Card = ({ s }) => (
  <Link to={`/service/${s.slug}`} data-testid={`home-service-${s.service_id}`} className="group w-56 shrink-0 rounded-2xl border border-slate-200 bg-white p-3 transition hover:shadow-md">
    {s.images?.[0]
      ? <img src={s.images[0]} alt={s.name} className="mb-2 h-28 w-full rounded-xl object-cover" />
      : <div className="mb-2 flex h-28 w-full flex-col items-center justify-center gap-1 rounded-xl bg-gradient-to-br from-fuchsia-100 via-violet-100 to-blue-100 text-fuchsia-500"><Sparkles className="h-7 w-7" /><span className="line-clamp-1 px-2 text-center text-[10px] font-semibold text-fuchsia-700/70">{s.name}</span></div>}
    <p className="line-clamp-1 text-sm font-semibold text-slate-800">{s.name}</p>
    <p className="mt-0.5 flex items-center gap-2 text-xs text-slate-400">
      {s.pricing_model === "custom_quote" ? "Custom quote" : `₹${s.price}`}
      {s.rating_count ? <span className="inline-flex items-center gap-0.5 text-amber-500"><Star className="h-3 w-3" />{s.rating_avg}</span> : null}
      {s.duration_minutes ? <span className="inline-flex items-center gap-0.5"><Clock className="h-3 w-3" />{s.duration_minutes}m</span> : null}
    </p>
  </Link>
);

const Rail = ({ title, items }) => items?.length ? (
  <section className="mb-4">
    <h3 className="mb-2 flex items-center gap-2 text-lg font-bold text-slate-900"><Sparkles className="h-5 w-5 text-fuchsia-500" /> {title}</h3>
    <div className="flex gap-3 overflow-x-auto pb-1">{items.map((s) => <Card key={s.service_id} s={s} />)}</div>
  </section>
) : null;

export default function ServicesHomeRail({ loc }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    const qs = new URLSearchParams();
    ["state", "district", "pincode"].forEach((k) => loc?.[k] && qs.set(k, loc[k]));
    api.get(`/marketplace/public/home-services?${qs.toString()}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [loc?.state, loc?.district, loc?.pincode]);

  if (!data) return null;
  const hasAny = (data.near_you?.length || data.featured?.length || data.trusted?.length);
  if (!hasAny) return null;

  return (
    <div className="mb-5 rounded-2xl border border-fuchsia-100 bg-fuchsia-50/30 p-4" data-testid="services-home-rail">
      <div className="mb-3 flex items-center justify-between">
        <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-xs font-semibold text-fuchsia-700 ring-1 ring-fuchsia-200"><Sparkles className="h-3.5 w-3.5" /> Book Services</span>
        <Link to="/services" data-testid="services-explore-all" className="inline-flex items-center gap-1 text-xs font-semibold text-fuchsia-700 hover:text-fuchsia-900">Explore all <ArrowRight className="h-3.5 w-3.5" /></Link>
      </div>
      <Rail title="Services near you" items={data.near_you} />
      <Rail title="Featured services" items={data.featured} />
      {data.trusted?.length ? (
        <section>
          <h3 className="mb-2 flex items-center gap-2 text-lg font-bold text-slate-900"><Star className="h-5 w-5 text-amber-400" /> Trusted providers</h3>
          <div className="flex flex-wrap gap-2">
            {data.trusted.map((t) => (
              <span key={t.seller_id} data-testid={`trusted-${t.seller_id}`} className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700">
                {t.name || "Provider"}{t.rating_avg ? <span className="inline-flex items-center gap-0.5 text-amber-500"><Star className="h-3 w-3" />{t.rating_avg}</span> : null}
              </span>
            ))}
          </div>
        </section>
      ) : null}
    </div>
  );
}
